module.exports = __webpack_public_path__ + "img/IMMERSE_FX_MOBILE_THUMBNAIL_HOME_PAGE.794de9af.jpg";